(() => {
  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return;
  const root = window.Shopify?.routes?.root || '/';
  let previousFocus, busy = false;
  function open() { previousFocus = document.activeElement; if (!drawer.open) drawer.showModal(); document.body.classList.add('cart-open'); drawer.querySelector('[data-cart-close]')?.focus(); }
  function close() { drawer.close(); document.body.classList.remove('cart-open'); previousFocus?.focus(); }
  async function render() {
    const response = await fetch(root + '?section_id=cart-drawer', {cache:'no-store'});
    if (!response.ok) throw new Error(drawer.dataset.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const panel = html.querySelector('[data-cart-panel]');
    if (!panel) throw new Error(drawer.dataset.error);
    drawer.replaceChildren(panel);
    const count = panel.querySelector('[data-cart-count]')?.dataset.cartCount || '0';
    document.querySelectorAll('[data-header-cart-count]').forEach(el => el.textContent = count);
  }
  function error(message) {
    const alert = drawer.querySelector('.drawer-error');
    if (alert) { alert.textContent = message || drawer.dataset.error; alert.hidden = false; }
  }
  document.querySelectorAll('.cart-link').forEach(link => link.addEventListener('click', async e => {
    e.preventDefault(); if (busy) return; busy = true;
    try { await render(); open(); } catch { window.location.href = link.href; } finally { busy = false; }
  }));
  document.querySelectorAll('.mask-form').forEach(form => form.addEventListener('submit', async e => {
    e.preventDefault(); if (busy) return; busy = true;
    const button = form.querySelector('[type=submit]'); button.disabled = true;
    let added = false;
    try {
      let request = {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}};
      if (form.dataset.componentCart === 'true') {
        const config = JSON.parse(document.querySelector('#v2').dataset.config);
        const count = Number(form.querySelector('input[name=tier]:checked').value);
        const picks = [...form.querySelectorAll('.tpicks select')].map(el => config.faces[Number(el.value)]);
        if (![1,3,6].includes(count) || picks.length !== count || picks.some(face => !face || !/^\d+$/.test(face.variant) || !face.sku)) {
          throw new Error('Please select a face for every mask.');
        }
        const grouped = new Map();
        for (const face of picks) grouped.set(face.variant, (grouped.get(face.variant) || 0) + 1);
        const items = [...grouped].map(([id, quantity]) => ({id, quantity, properties:{_fm_selection_size:String(count)}}));
        request = {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items})};
      }
      const response = await fetch(root + 'cart/add.js', request);
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || drawer.dataset.error);
      added = true;
      if(e.submitter?.hasAttribute('data-component-shop-pay')){
        const checkout=new URL(root+'checkout',location.origin);checkout.searchParams.set('payment','shop_pay');
        const q=new URLSearchParams(location.search);for(const key of ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id','fbclid'])if(q.has(key))checkout.searchParams.set(key,q.get(key));
        window.location.assign(checkout.href);return;
      }
      await render(); open();
    } catch (failure) {
      if (added) { window.location.href = root + 'cart'; return; }
      open(); error(failure.message);
    } finally { busy = false; button.disabled = false; }
  }));
  drawer.addEventListener('click', async e => {
    if (e.target === drawer || e.target.closest('[data-cart-close]')) { close(); return; }
    const button = e.target.closest('[data-cart-key]');
    if (!button || busy) return;
    busy = true;
    drawer.querySelectorAll('button').forEach(el => el.disabled = true);
    let changed = false;
    try {
      const response = await fetch(root + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({id:button.dataset.cartKey,quantity:Number(button.dataset.cartQuantity)})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || drawer.dataset.error);
      changed = true; await render(); drawer.querySelector('[data-cart-close]')?.focus();
    } catch (failure) {
      if (changed) { window.location.href = root + 'cart'; return; }
      error(failure.message);
    } finally { busy = false; drawer.querySelectorAll('button').forEach(el => el.disabled = false); }
  });
  drawer.addEventListener('close', () => { document.body.classList.remove('cart-open'); previousFocus?.focus(); });
})();
